import type { PatrolStatus } from "../types";

export type PatrolPeriodIso = { periodStartIso: string; periodEndIso: string };

/**
 * Some responses list window_start/window_end out of chronological order.
 * UI and deadline logic must use the actual interval [earlier, later].
 */
export function normalizePatrolWindow(
  patrolStatus: Pick<PatrolStatus, "window_start" | "window_end"> | null | undefined
): PatrolPeriodIso | null {
  if (!patrolStatus?.window_start || !patrolStatus?.window_end) return null;
  const a = new Date(patrolStatus.window_start).getTime();
  const b = new Date(patrolStatus.window_end).getTime();
  if (Number.isNaN(a) || Number.isNaN(b)) return null;
  if (a <= b) {
    return { periodStartIso: patrolStatus.window_start, periodEndIso: patrolStatus.window_end };
  }
  return { periodStartIso: patrolStatus.window_end, periodEndIso: patrolStatus.window_start };
}
